<template>
  <div>
    <loading
      :active.sync="isLoading"
      :can-cancel="false"
      :is-full-page="true"
      :opacity="0.99"
      :width="150"
      :height="150">
    </loading>
    <div v-if="profile && !isLoading">
      <div id="topbar" v-if="currentRouteName == 'home' && !isMultiDealerGroup && this.$route.query.print !== 'true'" class="preheaderElement">
        <div class="container">
          <a :href="websiteUrl" target="_blank" class="cc-active">
            <img :src="logoUrl">
            <strong>{{ name }}</strong>
          </a>
          <ul class="social">
            <li v-for="(network, index) in socialNetworks" :key=index><a :href="network.link" target="_blank"><i :class="`icon-${network.name}`"></i></a></li>
            <li class="d-none d-lg-block mx-3" v-if="phone"><a :href="`tel:${phone}`"><i class="icon-telephone mr-1"></i>{{ phone }}</a></li>
            <li class="d-none d-lg-block mr-3" v-if="mapUrl"><a :href="mapUrl" target="_blank"><i class="icon-map mr-1"></i> {{ $t('Ver Mapa') }}</a></li>
            <li class="d-none d-lg-block"><a href="javascript:;" v-scroll-to="{ el: '#inventory', offset: -100 }" @click="toggleMainNavDisplay"><i class="icon-search mr-1"></i> {{ $t('Búsqueda') }}</a></li>
          </ul>
        </div>
      </div>
      <header id="header" v-if="currentRouteName == 'home' && this.$route.query.print !== 'true'" class="headerElement">
        <div class="container">
          <div class="profile">
            <a href="javascript:;" class="pic"><img :src="profile.photo_url"></a>
            <div class="info">
              <h1>{{ profile.first_name }} {{ profile.last_name }}</h1>
              <p class="post">{{ profile.professional_title }}</p>
              <p><strong>Cel: </strong> <a :href="`tel:${profile.phone}`" class="hoverElement buttonElement">{{ profile.phone }}</a></p>
              <p><strong>{{ $t('Correo Electrónico') }}: </strong> <a :href="`mailto:${profile.email}`" class="hoverElement buttonElement">{{ profile.email }}</a></p>
            </div>
          </div>
          <button class="btn d-lg-none buttonElement" @click="toggleMainNavDisplay"><i class="icon-menu"></i></button>
          <nav :class="{ 'main-nav': true, 'mainNavDisplay': mainNavDisplay }">
            <ul class="quick-menu d-lg-none">
              <li><a :href="`tel:${profile.phone}`" class="buttonBackgroundBorder"><i class="icon-phone"></i> {{ $t('Llamar') }}</a></li>
              <li><a class="scrollTo buttonBackgroundBorder" href="#javascript:;" v-scroll-to="'#inventory'" @click="toggleMainNavDisplay()"><i class="icon-trade-in"></i> {{ $t('Inventario') }}</a></li>
              <li><a class="scrollTo buttonBackgroundBorder" href="#javascript:;" v-scroll-to="'#about'" @click="toggleMainNavDisplay()"><i class="icon-directions-metro"></i> {{ $t('Info') }}</a></li>
            </ul>
            <ul class="main-menu">
              <li><a class="scrollTo hoverElement buttonElement buttonBorder" href="javascript:;" v-scroll-to="{ el: '#topbar' }" @click="toggleMainNavDisplay" >{{ $t('Inicio') }}</a></li>
              <li><a class="scrollTo hoverElement buttonElement buttonBorder" href="javascript:;" v-scroll-to="{ el: '#inventory', offset: -180 }" @click="toggleMainNavDisplay">{{ $t('Inventario') }}</a></li>
              <li><a class="scrollTo hoverElement buttonElement buttonBorder" href="javascript:;" v-scroll-to="{ el: '#about', offset: -180 }" @click="toggleMainNavDisplay">{{ $t('Sobre mí') }}</a></li>
              <li>
                <a class="scrollToTab hoverElement buttonElement buttonBorder" href="javascript:;" @click="setTabID('contact-tab'), toggleMainNavDisplay()" v-scroll-to="{ el: '#contact-tab', offset: -180 }">{{ $t('Contactar') }}</a>
              </li>
              <li class="d-lg-none">
                <a class="scrollToTab hoverElement buttonElement buttonBorder" href="javascript:;" @click="setTabID('finance-tab'), toggleMainNavDisplay()" v-scroll-to="{ el: '#finance-tab', offset: -180 }">{{ $t('Solicitar Financiamiento') }}</a>
              </li>
              <li class="d-lg-none">
                <a class="scrollToTab hoverElement buttonElement buttonBorder" href="javascript:;" @click="setTabID('trade-tab'), toggleMainNavDisplay()" v-scroll-to="{ el: '#trade-tab', offset: -180 }">{{ $t('Cotización de Trade-in') }}</a>
              </li>
              <li class="d-lg-none">
                <a class="scrollToTab hoverElement buttonElement buttonBorder" href="javascript:;" @click="setTabID('ref-tab'), toggleMainNavDisplay()" v-scroll-to="{ el: '#ref-tab', offset: -180 }">{{ $t('Referir a un Amigo') }}</a>
              </li>
            </ul>
            <button @click="mainNavDisplay = false" class="btn text-secondary d-lg-none mx-auto d-block" style="z-index: 9999999!important;"><i class="icon-close"></i></button>
          </nav>
        </div>
      </header>
      <div id="app">
        <router-view />
      </div>
      <footer id="footer" v-if="this.$route.query.print !== 'true'" class="footerElement">
        <div class="container">
          <div class="row align-items-center justify-content-between">
            <div class="col-12 col-lg-4">
              <div class="copy">© {{ new Date().getFullYear() }}. {{ name }} All Rights Reserved. <br>
                † {{ $t('Precios y detalles pueden variar de los mostrados') }}
                <span>
                  <a href="javascript:;" class="hoverElement buttonElement">{{ $t('aquí') }}</a>. &nbsp;
                  <strong>* † ††</strong>
                  <div class="tooltip">
                    <span class="text-primary">*</span> {{ $t('Requerido') }} <br><br>
                    <span class="text-primary">†</span> {{ $t('precio_publicado_puede_variar') }}. <br><br>
                    <span class="text-primary">††</span> {{ $t('equipo_publicado_puede_variar') }}.
                  </div>
                </span>
              </div>
            </div>
            <div class="col-12 col-lg">
              <ul class="social">
                <li v-for="(social, index) in profile.social_networks" :key=index><a :href="social.link" target="_blank"><i :class="`icon-${social.name}`"></i></a></li>
              </ul>
            </div>
            <div class="col-12 col-lg-4 text-center">
              <a href="https://dealerappcenter.com/" target="_blank" class="dac"><i class="icon-logo-dac" alt="DealerAppCenter"></i></a>
            </div>
          </div>
        </div>
      </footer>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import hexToRgba from 'hex-to-rgba';
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';

export default {
  components: {
    Loading,
  },
  metaInfo() {
    return {
      title: this.profileFullName,
      titleTemplate: this.profileFullName,
    };
  },
  data() {
    return {
      isLoading: true,
      profile: null,
      dealerGroup: null,
      isMultiDealerGroup: false,
      mainNavDisplay: false,
      // Profile variables
      logoUrl: null,
      name: null,
      socialNetworks: null,
      phone: null,
      mapUrl: null,
      websiteUrl: null,
      banners: null,
    };
  },
  methods: {
    ...mapActions([
      'requestProfile',
      'requestDealerGroup',
      'requestRooftop',
    ]),
    applyCSS(colorScheme) {
      const nodeId = 'vue-style-hack';
      let style = document.getElementById(nodeId);
      if (!style) {
        style = document.createElement('style');
        style.id = nodeId;
        style.type = 'text/css';
        this.$el.appendChild(style);
      }

      const cssRule = `
        .backgroundTransparency { background-color: ${hexToRgba(colorScheme.accent || colorScheme.background, 0.75)}!important;}
        .footerElement { background-color: ${colorScheme.footer}!important; } 
        .headerElement { background-color: ${colorScheme.header}!important; } 
        .preheaderElement { background-color: ${colorScheme.pre_header}!important; } 
        .formElement { color: ${colorScheme.forms}!important; }
        .formBorder { border-color: ${colorScheme.forms}!important;}
        .formBackgroundBorder { background-color: ${colorScheme.forms}!important; border-color: ${colorScheme.forms}!important; }
        .buttonElement { color: ${colorScheme.accent}!important; }  
        .hoverElement:hover { color: ${colorScheme.hover}!important; }
        .buttonBackgroundBorder { background-color: ${colorScheme.accent}!important; border-color: ${colorScheme.accent}!important; }
        .buttonBorder { border-color: ${colorScheme.accent}!important;} 
        .beforeBorderTop:before { border-top: 2px solid ${colorScheme.accent}!important; } 
        .beforeColor:before { color: ${colorScheme.accent}!important; }
        .beforeBorderBot:before { border-bottom: 2px solid ${colorScheme.accent}!important; }
      `;
      style.innerHTML = cssRule;
    },
    toggleMainNavDisplay() {
      this.mainNavDisplay = !this.mainNavDisplay;
    },
    setTabID(tabID) {
      this.$store.commit('setTabID', tabID);
    },
  },
  computed: {
    currentRouteName() {
      return this.$route.name;
    },
    profileFullName() {
      return this.profile && this.profile.first_name && this.profile.last_name ? `${this.profile.first_name} ${this.profile.last_name}` : '';
    },
  },
  created() {
    // Get user profile information
    this.requestProfile(this.$route.params.username).then((userProfile) => {
      this.profile = userProfile;
      let colorScheme = null;
      if (this.profile && this.profile.rooftops) {
        // Check if the user has more than one rooftop
        if (this.profile.rooftops.length > 1) {
          // Check if the user belongs to multiple dealer groups
          const dealerGroupId = this.profile.rooftops[0].dealer_group_id;
          this.profile.rooftops.forEach((rooftop) => {
            if (dealerGroupId !== rooftop.dealer_group_id) {
              this.isMultiDealerGroup = true;
            }
          });
          // Set the profile information to the dealer group because of the multi rooftops
          this.requestDealerGroup({ username: this.$route.params.username, dGroupID: dealerGroupId }).then((dealerGroup) => {
            this.dealerGroup = dealerGroup;
            this.logoUrl = this.dealerGroup.logo_url;
            if (!this.isMultiDealerGroup) this.name = this.dealerGroup.name;
            else this.name = `${this.profile.first_name} ${this.profile.last_name}`;
            this.socialNetworks = this.dealerGroup.social_networks;
            this.phone = this.dealerGroup.phone;
            this.mapUrl = this.dealerGroup.map_url;
            this.websiteUrl = this.dealerGroup.website;
            this.$store.commit('setBanners', this.dealerGroup.banners);
            colorScheme = this.dealerGroup.colors_scheme;
            if (this.dealerGroup.colors_scheme) this.$store.commit('setColorScheme', this.dealerGroup.colors_scheme);
            // Shared data
            this.$store.commit('setSharedData', {
              isMultiDealerGroup: this.isMultiDealerGroup,
              phone: this.phone,
              address: this.dealerGroup.address,
              addressLink: this.dealerGroup.map_url,
              name: this.dealerGroup.name,
            });
            this.applyCSS(colorScheme || this.$store.getters.getColorScheme);
            this.isLoading = false;
          });
        } else {
          // Set the profile information to the rooftop
          const rooftopId = this.profile.rooftops[0].id;
          this.requestRooftop({ username: this.$route.params.username, rooftopID: rooftopId }).then((rooftop) => {
            this.rooftop = rooftop;
            if (this.rooftop.independent) {
              this.logoUrl = this.rooftop.logo_url;
            } else {
              this.requestDealerGroup({ username: this.$route.params.username, dGroupID: this.rooftop.dealer_group_id }).then((dealerGroup) => {
                this.dealerGroup = dealerGroup;
                this.logoUrl = this.rooftop.brand_logo_url;
              });
            }
            this.name = this.rooftop.name;
            this.socialNetworks = this.rooftop.social_networks;
            this.phone = this.rooftop.phone;
            this.mapUrl = this.rooftop.map_url;
            this.websiteUrl = this.rooftop.website;
            this.$store.commit('setBanners', this.rooftop.banners);
            colorScheme = this.rooftop.colors_scheme;
            if (this.rooftop.colors_scheme) this.$store.commit('setColorScheme', this.rooftop.colors_scheme);
            this.$store.commit('setSharedData', {
              isMultiDealerGroup: this.isMultiDealerGroup,
              phone: this.phone,
              address: this.rooftop.address,
              addressLink: this.rooftop.map_url,
              name: this.rooftop.name,
            });
            this.applyCSS(colorScheme || this.$store.getters.getColorScheme);
            this.isLoading = false;
          });
        }
      }
    });
  },
};
</script>

<style>
  #topbar .container .cc-active img {
    height: 25px;
  }
  .mainNavDisplay {
    display: block!important;
  }
  .rangeSlider {
    margin: 0 20px;
  }
  #inventory .inventory-list li .info:before {
    opacity: 0;
  }
  .hideArrows .flickity-button {
    display: none !important;
  }
  .fabs {
    padding: 0 10px 15px 15px;
  }
  .btn:focus {
    outline: none;
    box-shadow: none;
  }
</style>
